define.alias("shared/helpers/is-last", "settings/helpers/is-last");